import styled from 'styled-components';
import { Divider } from 'antd';

export const CustomDivider = styled(Divider)`
	margin: 0;
	height: 80px;
	border-left: 1px #262626 solid;
`;
